import { profileService } from '../services/profileService.js'
import { useSocketResync } from './useSocketResync.js'
import websocketService from '../services/websocketService.js'
import { getCurrentScope, onScopeDispose } from 'vue'

export function usePageVisibilitySnapshot(name, apply, { loading, onFailure } = {}) {
    let revision = 0
    let disposed = false
    if (getCurrentScope()) onScopeDispose(() => { disposed = true; revision++ })
    const load = async (isCurrent = () => true) => {
        const request = ++revision
        const generation = websocketService.generation
        const valid = () => !disposed && request === revision && generation === websocketService.generation && isCurrent()
        if (loading) loading.value = true
        try {
            for (const endpoint of ['/api/page-visibility', '/api/admin/page-visibility']) {
                try {
                    const data = await profileService.pageVisibilityAt(endpoint, { credentials: 'include' })
                    if (!valid()) return false
                    if (data) { apply(data); return true }
                } catch { /* Try the existing owner endpoint before marking the snapshot stale. */ }
            }
            if (valid()) onFailure?.()
            return false
        } finally { if (loading && request === revision) loading.value = false }
    }
    useSocketResync(name, load)
    return load
}
